(function () {
  function initExperts() {
    if (typeof Swiper === 'undefined') {
      return window.setTimeout(initExperts, 50);
    }

    document.querySelectorAll('.ctr-experts').forEach(function (section) {
      if (section.dataset.ctrInit) return;
      section.dataset.ctrInit = '1';

      // Hover-capable devices flip via CSS :hover; the tap handlers would
      // leave a stuck is-flipped state there, so they only act on touch.
      var hoverFlip = window.matchMedia('(hover: hover)');

      section.querySelectorAll('.ctr-experts__card').forEach(function (card) {
        var flip = card.querySelector('.ctr-experts__flip');
        card.addEventListener('click', function () {
          if (hoverFlip.matches) return;
          flip.classList.toggle('is-flipped');
        });
      });

      var carousel = section.querySelector('.ctr-experts__carousel');
      if (!carousel) return;
      var dots = section.querySelector('.ctr-experts__dots');

      new Swiper(carousel, {
        slidesPerView: 1.6,
        spaceBetween: 12,
        grabCursor: true,
        watchOverflow: true,
        breakpoints: {
          750: { slidesPerView: 2.5, spaceBetween: 16 },
          990: { slidesPerView: 4, spaceBetween: 24 }
        },
        pagination: dots ? { el: dots, clickable: true } : false
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initExperts);
  } else {
    initExperts();
  }
})();
